<template>
    <div id="footer"
         :class="data.classFooter"
    >
        <div id="footer-left">
            <a class="btn-main-func"
               :class="data.classBtnSettings"
               href="#"
               id="btn-settings"
               :title="i18n.t('tooltip_setting')"
               @click.prevent="toggleSettings"
            >
                <!-- note that child element has to be set 'no-pointer' class to make it not clickable, so that in the simple list component,
                the empty area click event can check the toggle button correctly-->
                <img class="no-pointer" src="~/images/btn_settings.png">
            </a>
            <simple-list
                    :arrowHorizontalPosition="'left'"
                    :arrowVerticalDirection="'down'"
                    :isToggle="data.isShowSettings"
                    :stylePos="data.styleSetting"
                    :triggerId="'btn-settings'"
                    @hidden="onSettingsHidden"
            >
                <Settings></Settings>
            </simple-list>

            <a class="btn-main-func"
               :class="data.classBtnInfo"
               href="#"
               id="btn-info"
               @click.prevent="toggleInfo"
            >
                <img class="no-pointer" src="~/images/btn_info.png">
            </a>
            <simple-list
                    :arrowHorizontalPosition="'left'"
                    :arrowVerticalDirection="'down'"
                    :isToggle="data.isShowInfo"
                    :stylePos="data.styleInfo"
                    :triggerId="'btn-info'"
                    @hidden="onInfoHidden"
            >
                <links></links>
            </simple-list>
        </div>
        <div id="footer-right">
           <img id="icon-search" src="~/images/icon_search.png">
           <input id="input-search-book"
                  type="text"
                  :placeholder="i18n.t('label_enter_keyword')"
                  v-model="booklistState.searchText"
                  autofocus
           >
           <btn-logout></btn-logout>
        </div>
    </div>
</template>

<script>

    import {ref, reactive, onMounted, watchEffect, computed, watch, inject, nextTick}  from "vue"
    import SimpleList from "@/views/lib/listing/SimpleList";
    import Links from "@/views/template/Links";
    import Settings from "@/views/template/Settings";
    import {useBookList} from "@/modules/home/booklist";
    import router from "@/router"
    import config from "@/config/config.json";
    import {isTouchDevice} from "@/modules/utils/deviceUtils";
    import BtnLogout from "@/views/footer/BtnLogout";

    export default {
        components:{
            BtnLogout,
            SimpleList,
            Settings,
            Links
        },
        setup(props, context) {

            const { booklistState } = useBookList();
            const i18n = inject('i18n');

            const data = reactive({
                isShowSettings:false,
                isShowInfo:false,
                isBtnSettingActive:false,
                isBtnInfoActive:false,
                styleInfo:{
                    left:"45px",
                    bottom:"55px",
                },
                styleSetting:{
                    bottom:"55px",
                },
                classFooter:computed(()=>{
                    return {
                        "no-touch": !isTouchDevice()
                    }
                }),
                classBtnSettings: computed(()=>{
                    return {
                        active:data.isShowSettings
                    }
                }),
                classBtnInfo:computed(()=>{
                    return {
                        active: data.isShowInfo
                    }
                })
            })
            const onSettingsHidden = (state)=>{
                data.isShowSettings = false;
            }

            const onInfoHidden = (state)=>{
                data.isShowInfo = false;
            }

            const toggleInfo = ()=>{
                data.isShowInfo = !data.isShowInfo
                data.isShowSettings = false;

            }

            const toggleSettings = ()=>{
                data.isShowSettings = !data.isShowSettings;
                data.isShowInfo = false;
            }

            onMounted(()=>{
                setTimeout(()=> {
                    document.getElementById("input-search-book").focus();
                }, config.elementControl.focusTimeout);
            })

            return {
                data,
                config,
                i18n,
                booklistState,
                toggleInfo,
                toggleSettings,
                onSettingsHidden,
                onInfoHidden

            }
        }
    }
</script>

<style scoped lang="scss">

    #footer {
        justify-content: flex-end;
    }

    #icon-search {
        width:$btn-main-func-size;
        height:$btn-main-func-size;
    }

    @mixin footer-full {
        #footer-right {
            width:100%;

            input {
                flex:1;
            }
        }
    }

    input {
        margin:0 5px 0 0;
        width:300px;
    }

    @include responsive(mobile-tiny) {
        @include footer-full
    }

    @include responsive(mobile) {
        @include footer-full
    }

    @include responsive(mobile-large) {
        @include footer-full
    }

    @include responsive(mobile-mega) {
        @include footer-full
    }

</style>